import { Navigate, Route, Routes } from "react-router";
import CommunitySpacesPage from "./spaces";
import CommunityMembersPage from "./members";
import CommunityAnalyticsPage from "./analytics";
import CommunitySpaceDetailPage from "./space-detail";

/**
 * Community module routing.
 * The backend contract is mounted under `/crm/communities/*`; this file
 * mounts the existing frontend surfaces into the authenticated app shell.
 */
export default function CommunityPage() {
  return (
    <Routes>
      <Route index element={<CommunitySpacesPage />} />
      <Route path="members" element={<CommunityMembersPage />} />
      <Route path="analytics" element={<CommunityAnalyticsPage />} />
      <Route path=":spaceId" element={<CommunitySpaceDetailPage />} />
      <Route path="*" element={<Navigate to="/community" replace />} />
    </Routes>
  );
}
